import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { User, Store } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [role, setRole] = useState("client");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register({ ...form, role });
      toast.success("Bienvenue dans la campagne !");
      nav("/dashboard");
    } catch (err) {
      toast.error(apiErr(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-4 py-12 bg-slate-100">
      <div className="w-full max-w-md card-cocarde p-8">
        <div className="flex justify-center mb-6"><Logo /></div>
        <h1 className="font-display text-3xl cc-navy text-center">CRÉER UN COMPTE</h1>

        <div className="grid grid-cols-2 gap-3 mt-6">
          {[{ v: "client", icon: User, l: "Client", d: "Commander & voter" }, { v: "pizzeria", icon: Store, l: "Pizzeria", d: "Partenaire réseau" }].map((r) => (
            <button key={r.v} type="button" onClick={() => setRole(r.v)} data-testid={`role-${r.v}`}
              className={`rounded-2xl border-2 p-4 text-left transition-all ${role === r.v ? "border-cc-red bg-red-50" : "border-slate-200"}`}>
              <r.icon size={22} className={role === r.v ? "text-cc-red" : "text-slate-400"} />
              <p className="font-display text-lg cc-navy mt-2">{r.l}</p>
              <p className="text-xs text-slate-500">{r.d}</p>
            </button>
          ))}
        </div>

        <form onSubmit={submit} className="mt-5 space-y-4">
          <input data-testid="reg-name" required placeholder="Nom / Nom de la pizzeria" value={form.name} onChange={set("name")}
            className="w-full border border-slate-300 rounded-xl px-4 py-3 focus:border-cc-red outline-none" />
          <input data-testid="reg-email" required type="email" placeholder="Email" value={form.email} onChange={set("email")}
            className="w-full border border-slate-300 rounded-xl px-4 py-3 focus:border-cc-red outline-none" />
          <input data-testid="reg-password" required type="password" placeholder="Mot de passe" value={form.password} onChange={set("password")}
            className="w-full border border-slate-300 rounded-xl px-4 py-3 focus:border-cc-red outline-none" />
          <button data-testid="reg-submit" disabled={busy} className="btn-cocarde w-full disabled:opacity-60">
            {busy ? "Création…" : "Créer mon compte"}
          </button>
        </form>
        <p className="text-center text-sm text-slate-500 mt-5">
          Déjà inscrit ? <Link to="/login" data-testid="go-login" className="text-cc-red font-bold">Se connecter</Link>
        </p>
      </div>
    </div>
  );
}
